/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type EvmAddressDetailInfo = {
    ADDR: string;
    ADDRT: EvmAddressDetailInfo.ADDRT;
    NM: string;
    BL: string;
    BLP: string;
    TKNCNT: string;
    FTRXUT: number;
    LTRXUT: number;
    CCADDR: string;
    CTRXHA: string;
};

export namespace EvmAddressDetailInfo {

    export enum ADDRT {
        EOA = 'EOA',
        CA = 'CA',
    }


}

